<template>
    <w-btn
        v-if="show"
        :color="error ? 'red' : 'orange'"
        :loading="loading"
        :disabled="disabled"
        :text="$t('common.edit')"
        :icon="error ? 'mdi-alert' : 'mdi-pencil-box-multiple'"
        @press="press"
    />
</template>

<script>
export default {
    name: 'WBtnUpdate',
    props: {
        show: Boolean,
        loading: Boolean,
        disabled: Boolean,
        error: Boolean,
    },
    emits: ['press'],
    setup(props, {emit}) {
        function press() {
            emit('press');
        }

        return {
            press,
        }
    }
}
</script>

<style scoped>

</style>